<template>
    <div>
        <div class="row">
            <div class="col-12">
                Group label: {{group.label}}
                <custom-input :option="group" :objKey="'label'"
                                     @changed="group.label = $event; groupHasChanged = true" >
                </custom-input>
            </div>
            <div class="col-12">
                Group preview type:
                <multiselect v-model="group.previewType"
                             :deselect-label="$t('UI.cantRemove')"
                             :max-height="600"
                             :multiple="false"
                             :closeOnSelect="false"
                             placeholder="Select template groups"
                             id="grouppicker"
                             :preserve-search="true"
                             :options="previewTypes"
                             :searchable="true"
                             :allow-empty="false"></multiselect>
            </div>
        </div>

        <button :class="['btn',
                        mode === 'addition' ? 'btn-primary' : 'btn-cph-primary-outline']"
                @click="mode === 'addition' ? $emit('add') : $emit('save')">
            {{mode === 'addition' ? 'Add' : 'Save'}}
        </button>
    
    </div>
</template>

<script type="text/babel">
import CustomInput from '../CustomInput';
import CssProps from '../Workspace/ValueEditor/CssProp/CssProp.vue';
import ObjectValue from '../Workspace/ValueEditor/ObjectValue';
import Multiselect from 'vue-multiselect';

export default {
    name: 'TemplateGroupEdition',
    data () {
        return {
            groupHasChanged: false,
            selectedPropValue: '',
            selectedProp: {
                value: ''
            },
            previewTypes: ['text', 'font', 'container']
        };
    },
    components: {
        CustomInput,
        CssProps,
        ObjectValue,
        Multiselect
    },
    props: {
        group: {
            type: Object
        },
        mode: {
            type: String
        }
    },
    methods: {
        handleDeletion ({index}) {
            this.group.options.splice(index, 1);
        }
    }
};

</script>

<style lang="scss" scoped>

</style>
